module.exports = __webpack_public_path__ + "media/images/area/area_shizuokaM400-b8abe6eafb2fc8f61ddfaca01d5b875b.jpg";